import { initialState } from './initialState';

/**
 * As an initial state,
 * we are merging default initial state and data from the local storage first
 */

const initReducerState = {
  isInitLoading: true,
  isLoading: false,
  isCreating: false,
  isUpdating: false,
  isDeleting: false,
  isError: false
};

export default () => ({
  ...initialState,
  ...{
    formPage: {
      ...initialState.formPage,
      ...initReducerState,
    },
    formData: {
      ...initialState.formData,
      ...initReducerState,
    },
  },
});
